// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3JqX4","fileBtn":"File_fileBtn__1v_Ze","closeBtn":"File_closeBtn__jbfaF","fileSelected":"File_fileSelected__3avbL","disabled":"File_disabled__1S6xn"};